<template>
    <div class="tratamientos-container">
        <v-btn color="primary" outlined @click="$emit('list:tratamiento')">
            <v-icon left>mdi-format-list-bulleted</v-icon>
            Tratamientos
        </v-btn>
        <v-btn color="primary" outlined @click="$emit('add:tratamiento')">
            <v-icon left>mdi-plus</v-icon>
            Nuevo Tratamiento
        </v-btn>

        <v-btn color="primary" outlined @click="$emit('list:modal')">
            <v-icon left>mdi-format-list-bulleted</v-icon>
            Tratamientos Modal
        </v-btn>
        <v-btn color="primary" outlined @click="$emit('add:modal')">
            <v-icon left>mdi-plus</v-icon>
            Nuevo Tratamiento Modal
        </v-btn>
    </div>
</template>

<script>


    export default {
        name: 'ActionsTratamientos',
        emits: [
            'list:tratamiento',
            'add:tratamiento',
            'list:modal',
            'add:modal',
        ]

    };

</script>


<style>

    .tratamientos-container {
        display: grid;
        gap: 1rem;
        grid-template-columns: repeat(4, minmax(200px, 1fr));
    }
</style>